<template lang="pug">
  div(
    class="e-chip-label"
    :style="styles"
  )
    e-svg-icon(
      v-if="prependIcon"
      :name="prependIcon"
    )
    span(
      class="text-12px"
      :style="textStyles"
    ) {{ text }}
    e-svg-icon(
      v-if="appendIcon"
      :name="appendIcon"
    )
</template>

<script>
export default {
  name: 'EChipLabel',
  props: {
    text: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: '#121212'
    },
    backgroundColor: {
      type: String,
      default: '#f0f0f0'
    },
    prependIcon: {
      type: String,
      default: null
    },
    appendIcon: {
      type: String,
      default: null
    }
  },
  computed: {
    styles() {
      return {
        backgroundColor: this.backgroundColor
      }
    },
    textStyles() {
      return {
        color: this.color
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.e-chip-label {
  display: flex;
  align-items: center;
  gap: 4px;

  padding: 4px 8px;
  border-radius: 20px;
}
</style>
